module.exports = __webpack_public_path__ + "static/media/top_logo.08336f5c.PNG";